'use strict';
require('./signup.controller');

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('signup', {
        url: '/signup',
        templateUrl: 'app/signup/signup.html',
        controller: 'SignupCtrl',
        controllerAs: '$ctrl'
      })
      .state('signupSuccess', {
        url: '/signup/success',
        controller: 'SignupSuccessCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'app/signup/signupSuccess.html',
      })
      .state('signupFail', {
        url: '/signup/fail',
        templateUrl: 'app/signup/signupFail.html',
        controller: 'SignupFailCtrl',
        controllerAs: '$ctrl',
        params: {
          status: null
        }
      });
  });